import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ButtonPlay } from './button';
import { GetGame } from '../../pages/GameOverview/GetGame/getGame';
import { IGame } from '../../providers/Games/useGames';

export const GamePurchasePane = ({
	url,
	id,
	idOwned,
	iconUrl,
	gamePaper,
	gameData,
}: {
	url: string;
	id: string;
	idOwned: boolean;
	gamePaper: string;
	iconUrl: string;
	gameData: IGame;
}) => {
	return (
		<Flex
			flexDirection="column"
			width="100%"
			gridGap={{ base: '8px', hashup: '12px' }}
		>
			<GetGame
				iconUrl={iconUrl}
				url={url}
				id={id}
				isOwned={idOwned}
				game={gameData}
			/>
			<Flex
				flexDirection="row"
				gridGap="8px"
				width={{ base: '100%', hashup: 'unset' }}
			>
				{/* <ButtonChart isLightThemed={isLightThemed} /> */}
				{gameData.platforms.includes('html') && <ButtonPlay gameRef={gameData.gameUrl} />}
			</Flex>
		</Flex>
	);
};
